import { TylerMatTableDataSource } from './../../shared-components/angular-material/extended.class';

// This class exists purely for making the data work with the mattable
export class AssessmentDataCategory {

	// Properties
	category: string;
	testName: string;
	fullTitle: string;
	fields: string[] = [];
    data: object[] = [];
    subTableData: TylerMatTableDataSource;
    instanceId: number;

    // Methods
    createSubTableData() {
        // POST: constructs the sub-table data source from the data
        this.subTableData = new TylerMatTableDataSource(this.data);
    }

	minTableWidth() {
		// POST: gives you the minimum width for the corresponding table
		return (this.fields.length * 150) + 50;
	}

	contains (checkedDatum: {[key: string]: string}): boolean {
		// PRE: a dictionary to check
		// POST: returns true if the checked dictionary is in the data
		for (let i = 0; i < this.data.length; i++) {
			const datum = this.data[i];
			let equivalent = true;
			for (let j = 0; j < this.fields.length; j++) {
				const field = this.fields[j];
				if (datum[field] != checkedDatum[field]) {
					equivalent = false;
				}
			}
			if (equivalent) {
				return true;
			}
		}
		return false;
	}

	sort(field: string, object = null, direction = 'desc') {
		// POST: sorts the data in order of a specified field
		if (this.fields.includes(field)) {
			this.data.sort((a, b) => {
				if (object) {
					const objectA = object.__proto__.constructor(a);
					const objectB = object.__proto__.constructor(b);
					if ((objectA < objectB && direction == 'desc') ||
						(objectA > objectB && direction == 'asc')) {
						return -1;
					} else if ((objectB < objectA && direction == 'desc') ||
							   (objectB > objectA && direction == 'asc')) {
						return 1;
					} else {
						return 0;
					}
				} else {
					if ((a[field] < b[field] && direction == 'desc') ||
						(a[field] > b[field] && direction == 'asc')) {
						return -1;
					} else if ((b[field] < a[field] && direction == 'desc') ||
							   (b[field] > a[field] && direction == 'asc')) {
						return 1;
					} else {
						return 0;
					}
				}
			});
		}
	}
}
